// app/modules/admin/admin.routes.ts

import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
export const dashboardRoutes: Route[] = [
    {
        path: 'dashboard',
        canActivate: [AuthGuard],
        component: LayoutComponent,
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./pages/dashboard/dashboard.component').then(
                        (c) => c.DashboardComponent
                    ),
            },
        ],
    },
];
